<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="resumeResults">
    <ion-card class="resume-card">
      <ion-card-header>
        <div class="summary-controls">
          <div class="summary-month">
            <span class="section-title">Ver Resumen</span>
            <div class="month-picker-wrapper" (click)="openFilterByRange()">
              <ion-icon name="calendar-outline"></ion-icon>
              <span *ngIf="selectedRange"><strong>{{ selectedRange }}</strong></span>
            </div>
          </div>
        </div>
      </ion-card-header>
      <ion-card-content>
        <div class="summary-layout">
          <div class="summary-tile total">
            <span class="tile-label">{{ ia_template.settings[0].total_invoices_label || "Facturas Totales"}}</span>
            <span class="tile-value">{{ totalCount | currency : 'COP':'' }}</span>
          </div>
          <div class="state-grid">
            <div class="summary-tile state-tile" *ngFor="let states of statesCount"
              [ngClass]="returnState(states.state).class">
              <span class="tile-value">{{ states.total | currency : 'COP':'' }}</span>
              <span class="tile-label">{{ returnState(states.state).name }}</span>
            </div>
          </div>
          <div class="summary-tile points">
            <span class="tile-label">Puntos Ganados</span>
            <span class="tile-value">{{ (totalPointsCount || 0) | currency : 'COP':'' }}</span>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-card class="filters-card">
      <ion-card-header>
        <ion-card-title>Busca y filtra resultados</ion-card-title>
        <ion-card-subtitle>Combina los filtros para encontrar actividades específicas.</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="filters-grid">
          <div class="filter-column">
            <div class="filter-field">
              <label for="search-bar">Buscar</label>
              <mat-form-field appearance="none">
                <input matInput type="text" id="search-bar" placeholder="Escribe nombre, código o palabra clave"
                  [(ngModel)]="searchTerm" debounce="500">
              </mat-form-field>
            </div>

            <div class="filter-field">
              <label for="filter-by-activity">
                Filtrar por actividad
                <span *ngIf="filterByActivity" class="active-filter-label">Filtrando: {{ selectedActivityName }}</span>
              </label>
              <mat-form-field appearance="none" class="filter-activity-field">
                <input matInput type="text" id="filter-by-activity" placeholder="Selecciona una actividad"
                  (focus)="onSearchbarFocus()" (blur)="onBlurChange()" (input)="onSearchChange($event)">
              </mat-form-field>

              <div class="active-filter-chip" *ngIf="filterByActivity">
                <ion-icon name="funnel-outline"></ion-icon>
                <span>{{ selectedActivityName }}</span>
                <button type="button" aria-label="Quitar filtro de actividad" (click)="clearActivityFilter()">Quitar</button>
              </div>

              <ion-list *ngIf="optionsVisible" class="dropdown-list">
                <ion-item *ngIf="filterByActivity" (click)="clearActivityFilter()" class="clear-filter-option">
                  <ion-label>Quitar filtro</ion-label>
                  <ion-icon slot="end" name="close-circle-outline"></ion-icon>
                </ion-item>
                <ion-item *ngFor="let item of listActivities" (click)="applyingFilters(item)"
                  [class.is-selected]="selectedActivityId === item.id">
                  <ion-label>{{ item.name }}</ion-label>
                  <ion-icon *ngIf="selectedActivityId === item.id" slot="end" name="checkmark-circle"></ion-icon>
                </ion-item>
                <ion-item *ngIf="listActivities.length === 0">
                  <ion-label>No se encontraron actividades.</ion-label>
                </ion-item>
              </ion-list>
            </div>
            <ion-button expand="block" (click)="applyingFilters()" class="submit-button">
              Buscar
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="resultsFiltered?.length" class="results-card">
      <ion-list lines="none">
        <ion-item *ngFor="let result of resultsFiltered" lines="none" class="result-item">
          <div class="result-wrapper">
            <div class="result-header">
              <h3 class="result-title">{{ result.activity_name }}</h3>
              <span class="status-badge" [ngClass]="returnState(result.state).class">
                {{ result.state === 'MANUAL_VALIDATION' ? 'Pendiente de validación' : result.state === 'REJECTED' ? 'No
                aprobada' : 'Aprobada' }}
              </span>
            </div>
            <div class="result-body">
              <div class="result-preview">
                <iframe *ngIf="result.isPdf" [src]="result.file" class="result-document" frameborder="0" allowfullscreen
                  allow="fullscreen"></iframe>
                <img *ngIf="!result.isPdf" [src]="result.file" alt="Imagen de factura" class="result-document">
              </div>
              <div class="result-details">
                <div class="detail-block">
                  <span class="detail-label"># {{ result.id }}</span>
                </div>
                <div class="detail-block">
                  <span class="detail-label">Puntos ganados</span>
                  <span class="detail-value">{{ (result.total_points || 0) | currency : 'COP':'' }}</span>
                </div>
                <div class="detail-block">
                  <span class="detail-label">Fecha subida</span>
                  <span class="detail-value">{{ result.created }}</span>
                </div>
                <div class="detail-block" *ngIf="result.player_name">
                  <span class="detail-label">Subida por</span>
                  <span class="detail-value">{{ result.player_name }}</span>
                </div>
                <ion-button *ngIf="result.state === 'REJECTED' || result.state === 'MANUAL_VALIDATION'" size="small"
                  fill="outline" color="secondary" class="rules-button" (click)="showFailedRules(result.failed_rules)">
                  Reglas no aprobadas
                </ion-button>
              </div>
            </div>
          </div>
        </ion-item>
      </ion-list>
    </ion-card>

    <ion-card *ngIf="resultsFiltered?.length === 0">
      <ion-item lines="none" class="empty-state">
        <ion-icon name="search-outline"></ion-icon>
        <ion-label>No se encontraron resultados.</ion-label>
      </ion-item>
    </ion-card>

    <ion-infinite-scroll *ngIf="resultsFiltered?.length >= 10" threshold="100px"
      (ionInfinite)="ionInfiniteScroll($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando más resultados...">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ng-container>
</ion-content>
